import React from 'react';

const AgenciesPage = () => {
  return (
    <div>
      <h1>Agencies</h1>
    </div>
  );
};

export default AgenciesPage;
